import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './split-payment.module.css';
import { t } from 'i18next';
import { GlobalService } from '../../hexagonal-architecture-frontend-base/src/domain/services/Global.service';
import {
  useSelectedPatientValue,
  useSelectedQuoteValue,
  useSessionValue,
  // useSetSelectedPatient,
  // useSetSelectedQuote,
  // useUpdateDeal,
  // useUpdatePatient,
  useUpdateQuote,
  useViewport,
  // useCloneQuote,
  useUserSignData,
  useResolvedLuraSignUserData,
} from '../../hooks';
import {
  // useGetDocumentInfo,
  // useGetTemplateInfo,
  useShowErrorPopup,
  // useSignUrl,
  useUserAddress,
} from '../../hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { Select } from '../../components/selects';
import { useForm } from '@tanstack/react-form';
import { validate } from '../../utils';
import { Input } from '../../components/Inputs/input';
import { Button, GoBackArrow, TopMenu } from '../../components';
import { testBicValidator } from '../../services';
// import { IPatient } from '../../hexagonal-architecture-frontend-base/src/domain/models/IPersona';
// import { SignTemplate } from '../../ts';
import AddressBlock from '../../components/AddressBlock';
import RegularSpinner from '../../components/Spinner/RegularSpinner';
import Loader from '../../components/Loaders/Loader';
import { documentsData } from '../../consts/pdf-documents/documents';
import { useCreateHtmlSignDocument } from '../../hooks/documents';
import { ConsentHtmlSignDocumentData } from '../../ts/interfaces/documents/consent-html-sign-document-data';
import { useAtom } from 'jotai';
import { selectedQuoteIdAtom } from '../../store/global/atoms/quotes-atoms/selected-quote-atom';
import { getPatientsQuotesAtom } from '../../store/global/atoms/patients-atoms/getters/get-patients-quotes-atom';
// import { dealPaymentTypes } from '../../consts';
// import { createPaymentList } from '../../utils/create-payment-list';

const cx = classNames.bind(styles);
// const DOCUMENT_TEMPLATE_ID = process.env.REACT_APP_DOCUMENT_TEMPLATE_ID_SEPA;
const FEES = 38;

const formatIBAN = (value: string) => {
  return value
    .replace(/\s/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim();
};

/* =========================
     GET GEOLOCATION, IP AND USERAGENT
  ========================= */
const getClientMetadata = async () => {
  let geoLocation = {};
  let ipAddress = '';
  const userAgent = navigator.userAgent;

  // Geolocation
  if (navigator.geolocation) {
    try {
      geoLocation = await new Promise(resolve => {
        navigator.geolocation.getCurrentPosition(
          pos => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => resolve({}),
        );
      });
    } catch (error) {
      console.error('Error retrieving gelocation: ', error);
    }
  }

  // IP fetch from public API
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    ipAddress = data.ip || '';
  } catch (error) {
    console.error('Error retrieving ip: ', error);
  }

  return { geoLocation, ipAddress, userAgent };
};

const SplitPayment = () => {
  const { patientId, reportId } = useParams();
  const { viewportWidth } = useViewport();
  const { selectedPatient } = useSelectedPatientValue();
  const { userInfo } = useSessionValue();
  const { selectedQuote } = useSelectedQuoteValue();
  const navigate = useNavigate();
  // const { getTemplateInfo, isLoading: isLoadingTemplateInfo } = useGetTemplateInfo();
  // const { getSignUrl, signUrl, isLoading: isLoadingSignUrl } = useSignUrl();
  const { luraSignUserData } = useResolvedLuraSignUserData(userInfo?.zohoId);
  // const { getDocumentInfo } = useGetDocumentInfo();
  const { showErrorPopup } = useShowErrorPopup();
  const { userAddress } = useUserAddress();
  const { updateQuote } = useUpdateQuote();

  const { createHtmlSignDocument } = useCreateHtmlSignDocument();
  const [selectedQuoteId, setSelectedQuoteId] = useAtom(selectedQuoteIdAtom);
  const [quotesMutation] = useAtom(getPatientsQuotesAtom);

  useEffect(() => {
    if (reportId && selectedQuoteId !== reportId) {
      setSelectedQuoteId(reportId);
    }
  }, [reportId, setSelectedQuoteId, selectedQuoteId]);

  useEffect(() => {
    if (patientId && !quotesMutation.data && !quotesMutation.isPending) {
    // Busca la función mutate dentro del objeto que devuelve el átomo
    // @ts-ignore - Solo para verificar si existe la función
    quotesMutation.mutate?.({ names: [patientId], page: 1 });
    }
  }, [selectedQuote, reportId]);

  // const isLoadingTemplate = isLoadingTemplateInfo || isLoadingSignUrl;

  const dataToHoldRef = useRef({
    consentId: selectedPatient.dealDetails.Archivo_Consentimientos?.length
      ? selectedPatient.dealDetails.Archivo_Consentimientos[0].id
      : '',
    contactConsentId: selectedPatient.Consentimientos?.length
      ? selectedPatient.Consentimientos[0].id
      : '',
    dealId: selectedPatient.dealDetails.id,
    dealName: selectedPatient.dealDetails.Deal_Name,
    // docId: signUrl?.docId,
    patientId: selectedPatient.id,
    patientName: selectedPatient.title,
    // reqId: signUrl?.reqId,
    luraSignUserId: luraSignUserData?.id,
  });

  dataToHoldRef.current = {
    consentId: selectedPatient.dealDetails.Archivo_Consentimientos?.length
      ? selectedPatient.dealDetails.Archivo_Consentimientos[0].id
      : '',
    contactConsentId: selectedPatient.Consentimientos?.length
      ? selectedPatient.Consentimientos[0].id
      : '',
    dealId: selectedPatient.dealDetails.id,
    dealName: selectedPatient.dealDetails.Deal_Name,
    // docId: signUrl?.docId,
    patientId: selectedPatient.id,
    patientName: selectedPatient.title,
    // reqId: signUrl?.reqId,
    luraSignUserId: luraSignUserData?.id,
  };

  const [totalAmount, setTotalAmount] = useState<number>(selectedQuote?.Grand_Total ?? 0);
  const [numberOfPayments, setNumberOfPayments] = useState<string>('1');
  const [numberOfPaymentsOptionsState, setNumberOfPaymentsOptions] = useState<
    { value: string; content: JSX.Element }[]
  >([]);
  const [firstPayment, setFirstPayment] = useState<number>(0);
  const [totalAmountMonthly, setTotalAmountMonthly] = useState<number>(0);
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  // const [textToShow, setTextToShow] = useState<string>('establishConnection');
  // const [getData, setGetData] = useState<boolean>(true);
  const [bicCode, setBicCode] = useState<string>('');
  const [showDocument, setShowDocument] = useState<boolean>(true);
  const [searchiingBic, setSearchiingBic] = useState<boolean>(true);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [financialCost, setFinancialCost] = useState<number>(0);
  const [iban, setIban] = useState<string>('');
  // const { removeSelectedQuote } = useSetSelectedQuote();
  // const { removeSelectedPatient } = useSetSelectedPatient();
  // const { updatePatient } = useUpdatePatient();
  const { userSignData } = useUserSignData();

  const textBase = 'pages.informeDetallado';
  const tutorName = userInfo?.tutorFullName;
  // let timer: any;

  const topMenuProperties: any = {
    title: `${GlobalService.uppercaseFirstLetter(t(`${textBase}.mainTitle`))}: ${
      selectedPatient.title
    }`,
    user: tutorName,
  };

  const isScreenBig = viewportWidth > 768;
  useEffect(() => {
    if (
      selectedPatient.dealDetails.Pagos !== undefined &&
      selectedPatient.dealDetails.Pagos !== null
    )
      navigate('/personas');
  }, [selectedPatient]);

  useEffect(() => {
    if (!selectedQuote?.Access_To_Receipt_Payment_Method) {
      updateQuote.accessToReceiptPaymentMethod(selectedQuote?.id as string, true);
    }
  }, [selectedQuote]);

  useEffect(() => {
    let options: { value: string; content: JSX.Element }[] = [];
    if ((totalAmount ?? 0) >= 300 && (totalAmount ?? 0) < 600) {
      options = [
        { value: '1', content: <span>1</span> },
        { value: '2', content: <span>2</span> },
        { value: '3', content: <span>3</span> },
      ];
    } else if ((totalAmount ?? 0) >= 600 && (totalAmount ?? 0) < 1000) {
      options = [
        { value: '1', content: <span>1</span> },
        { value: '2', content: <span>2</span> },
        { value: '3', content: <span>3</span> },
        { value: '4', content: <span>4</span> },
        { value: '5', content: <span>5</span> },
        { value: '6', content: <span>6</span> },
      ];
    } else if ((totalAmount ?? 0) >= 1000) {
      options = [
        { value: '1', content: <span>1</span> },
        { value: '2', content: <span>2</span> },
        { value: '3', content: <span>3</span> },
        { value: '4', content: <span>4</span> },
        { value: '5', content: <span>5</span> },
        { value: '6', content: <span>6</span> },
        { value: '7', content: <span>7</span> },
        { value: '8', content: <span>8</span> },
        { value: '9', content: <span>9</span> },
        { value: '10', content: <span>10</span> },
        { value: '11', content: <span>11</span> },
        { value: '12', content: <span>12</span> },
      ];
    }
    setNumberOfPaymentsOptions(options);
  }, [totalAmount]);

  useEffect(() => {
    setTotalAmount(selectedQuote?.Grand_Total ?? 0);
    const numberOfPaymentsCounter: number = parseInt(numberOfPayments);
    let monthlyPayment = 0;
    let financialCost = 0;
    let firstPayment = totalAmount;
    if (numberOfPaymentsCounter > 2) {
      monthlyPayment = parseFloat((totalAmount / numberOfPaymentsCounter).toFixed(2));
      financialCost = parseFloat((totalAmount * 0.07).toFixed(2));
      setFinancialCost(financialCost);
      firstPayment = FEES + financialCost + monthlyPayment;
    } else if (numberOfPaymentsCounter === 2) {
      monthlyPayment = parseFloat((totalAmount / numberOfPaymentsCounter).toFixed(2));
      firstPayment = monthlyPayment;
    }

    setFinancialCost(financialCost);
    setFirstPayment(firstPayment ? parseFloat(firstPayment.toFixed(2)) : 0);
    setTotalAmountMonthly(monthlyPayment ? monthlyPayment : 0);
  }, [numberOfPayments, firstPayment, selectedQuote]);

  const form = useForm({
    defaultValues: {
      accountName: '',
      address: '',
      iban: '',
      bic: '',
      country: '',
    },
    onSubmit: async () => {
      setShowDocument(false);
      setShowMessage(false);
      setShowSpinner(true);
      /**
       * For local dev porpouses: avoid sign sepa doc
       *  uncomment handleSelectPayMethod() and comment fetchData() to avoid sign
       */

      // fetchData(selectedPatient, values.value.iban, bicCode);
      // setIsPopupOpen(true);
      const { geoLocation, ipAddress, userAgent } = await getClientMetadata();
       console.log('LURA SIGN USER ID ', dataToHoldRef.current.luraSignUserId);
      createHtmlSignDocument(
        {
          userId: dataToHoldRef.current.luraSignUserId as string,
          documentByCountryId: documentsData['SEPA']['es-ES'].documentId,
          ipAddress,
          userAgent,
          geoLocation,
          metadata: {},
          data: {
            debtorName: userSignData.tutorFullName,
            debtorAddress: userAddress?.Direcci_n,
            debtorCountry: userAddress?.Pa_s,
            debtorSwift: bicCode,
            debtorZipCode: userAddress?.Codigo_postal,
            debtorIban: iban,
            numberOfPayments: numberOfPayments,
            firstPaymentAmount: String(firstPayment),
            recurringPaymentAmount: String(totalAmountMonthly),
            totalAmount: String(totalAmount),
            singlePaymentAmount: numberOfPayments === '1' ? String(totalAmount) : '0',
            legalRepName: '',
            legalRepId: '',
            patientName: dataToHoldRef.current.patientName,
            patientId: userSignData.patientId,
            tutorEmail: userSignData.email,
            tutorFullName: userSignData.tutorFullName,
            tutorCountryId: userSignData.tutorCountryId,
            patientCountryId: userSignData.patientCountryId,
            documentCategory: 'SEPA',
            quoteId: selectedQuote?.id ?? reportId ?? '',
            dealId: selectedPatient.dealDetails.id,
          },
          locale: 'es-ES',
        },
        {
          onError: error => {
            showErrorPopup(`errors.${error.message}`);
            console.log('error in createPreConsentHtmlSignDocument ');
          },
          onSuccess: consentHtmlSignDocumentCreated => {
            if ((consentHtmlSignDocumentCreated as ConsentHtmlSignDocumentData).isOk) {
              navigate(`/informeDetallado/${patientId}/${reportId}/paymentmethod/splitpayment/${(consentHtmlSignDocumentCreated as ConsentHtmlSignDocumentData).htmlDocumentId}`,
                {
                  state: {
                    iban: iban,
                    bicCode: bicCode,
                    totalAmount: totalAmount,
                    firstPayment: firstPayment,
                    totalAmountMonthly: totalAmountMonthly,
                    numberOfPayments: numberOfPayments,
                    financialCost: financialCost,
                    FEES: FEES,
                  },
                },
              );
            }
          },
        },
      );
    },
  });

  const isValidIBAN = (iban: string) => {
    const cleanIBAN = iban.replace(/\s+/g, '').toUpperCase();
    const rearranged = cleanIBAN.slice(4) + cleanIBAN.slice(0, 4);
    const numericIBAN = rearranged
      .split('')
      .map(char => {
        const code = char.charCodeAt(0);
        return code >= 65 && code <= 90 ? code - 55 : char;
      })
      .join('');
    const remainder = BigInt(numericIBAN) % 97n;
    return remainder === 1n;
  };

  const backLink = `/informeDetallado/${patientId}/${reportId}/paymentMethod`;

  return (
    <div className={cx('main-container')}>
      <TopMenu {...topMenuProperties} />

      {showDocument && !showMessage && (
        <div className={cx('body-container')}>
          {isScreenBig && (
            <div className={cx('title--container')}>
              <GoBackArrow to={backLink} />

              <h3 className={cx('title--text')}>
                {GlobalService.uppercaseFirstLetter(t(`pages.paymentMethod.split`))}
              </h3>
            </div>
          )}
          {selectedQuote && totalAmount !== 0 ? (
            <div className={cx('body-container-main')}>
              <div className={cx('form-container', 'bs-20')}>
                <p>
                  {`${GlobalService.uppercaseFirstLetter(
                    t('modal.splitPayment.totalAmount'),
                  )} ${totalAmount}€. ${GlobalService.uppercaseFirstLetter(
                    t('modal.splitPayment.choosePayment'),
                  )}`}
                  <br />
                  <span className={cx('added-fees')} style={{ display: 'block' }}>
                    {`${GlobalService.uppercaseFirstLetter(t('modal.splitPayment.addedFees'))}`}
                  </span>
                </p>
                <p>{t(`modal.splitPayment.selectNumberPayments`)}</p>
                <div>
                  {t(`modal.splitPayment.selectNumberPaymentsLable`)}
                  <Select
                    label={numberOfPayments}
                    setValue={setNumberOfPayments}
                    options={numberOfPaymentsOptionsState}
                  />
                </div>

                <div className={cx('details-container')}>
                  <p>
                    <span className={cx('title')}>
                      {GlobalService.uppercaseFirstLetter(
                        t('modal.splitPayment.totalAmountFirstPayment'),
                      )}
                    </span>{' '}
                    {firstPayment}€
                  </p>
                  {parseInt(numberOfPayments) > 1 ? (
                    <p>
                      <span className={cx('title')}>
                        {GlobalService.uppercaseFirstLetter(
                          t('modal.splitPayment.totalAmountMonthly'),
                        )}{' '}
                      </span>
                      {totalAmountMonthly}€
                    </p>
                  ) : null}
                </div>
              </div>

              <div className={cx('form-container', 'bs-20')}>
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    form.handleSubmit();
                  }}
                  className={cx('flex flex-col gap-2 mx-2')}
                >
                  <form.Field
                    name={'accountName'}
                    validators={{
                      onChange: value => (validate(value.value, 'name') ? undefined : 'error.'),
                    }}
                    // eslint-disable-next-line react/no-children-prop
                    children={field => (
                      <Input
                        id={field.name}
                        label={GlobalService.uppercaseFirstLetter(
                          t('modal.splitPayment.accountHolder'),
                        )}
                        placeholder=''
                        type={'text'}
                        value={field.state.value}
                        onChange={field.handleChange}
                        onBlur={field.handleBlur}
                        errorMessage={field.state.meta.errors.join(', ')}
                      />
                    )}
                  />
                  <form.Field
                    name={'iban'}
                    validators={{
                      onChange: value => {
                        return validate(value.value, 'iban') && isValidIBAN(value.value)
                          ? undefined
                          : GlobalService.uppercaseFirstLetter(t('modal.splitPayment.errorIban'));
                      },
                      onChangeAsync: async val => {
                        const ibanValue = val.value.replace(/\s+/g, '');
                        if (validate(ibanValue, 'iban')) {
                          try {
                            setIban(ibanValue);
                            const searchBic = await testBicValidator(ibanValue.slice(4, 8));
                            if (searchBic === 'DontExistInDatabase' && searchiingBic) {
                              setBicCode('-');
                              setSearchiingBic(true);
                            } else {
                              setBicCode(searchBic);
                              setSearchiingBic(false);
                            }
                          } catch (error) {
                            console.error('Error fetching BIC', error);
                            return GlobalService.uppercaseFirstLetter(
                              t('modal.splitPayment.errorFetchingBic'),
                            );
                          }
                        } else {
                          return GlobalService.uppercaseFirstLetter(
                            t('modal.splitPayment.errorIban'),
                          );
                        }
                      },
                      onChangeAsyncDebounceMs: 1000,
                      onChangeListenTo: ['iban', 'bic'],
                    }}
                    // eslint-disable-next-line react/no-children-prop
                    children={field => (
                      <Input
                        id={field.name}
                        label={GlobalService.uppercaseFirstLetter(t('modal.splitPayment.iban'))}
                        placeholder=''
                        type={'text'}
                        value={formatIBAN(field.state.value.toLocaleUpperCase())}
                        onChange={field.handleChange}
                        onBlur={field.handleBlur}
                        errorMessage={field.state.meta.errors.join(', ')}
                      />
                    )}
                  />
                  <form.Field
                    name={'bic'}
                    validators={{
                      onChange: value => {
                        setSearchiingBic(value.value.length === 0);
                        return undefined;
                      },
                      onChangeListenTo: ['iban', 'bic'],
                    }}
                    // eslint-disable-next-line react/no-children-prop
                    children={field => (
                      <Input
                        id={field.name}
                        label={t('modal.splitPayment.bic')}
                        placeholder=''
                        type={'text'}
                        value={field.state.value || bicCode}
                        onChange={field.handleChange}
                        onBlur={field.handleBlur}
                        errorMessage={field.state.meta.errors.join(', ')}
                        disabled={true}
                      />
                    )}
                  />
                  <form.Field
                    name={'address'}
                    validators={{
                      onChange: ({ value }) =>
                        validate(value, 'Direcci_n') ? undefined : 'error.',
                    }}
                    // eslint-disable-next-line react/no-children-prop
                    children={() => (
                      <AddressBlock isScreenBig={isScreenBig} title={'Direccion'} />
                    )}
                  />
                  <form.Subscribe
                    // @ts-ignore
                    selector={state => [state.canSubmit, state.isSubmitting]}
                    // @ts-ignore
                    // eslint-disable-next-line react/no-children-prop
                    children={([canSubmit, isSubmitting]) => (
                      <Button
                        styleType='primary'
                        disabled={
                          canSubmit &&
                          numberOfPayments === t('modal.splitPayment.numberPayments')
                        }
                        fullWidth={true}
                        type='submit'
                        isLoading={isSubmitting}
                      >
                        {isSubmitting ? (
                          <Loader size='23px' border='3px' />
                        ) : (
                          GlobalService.uppercaseFirstLetter(t('modal.splitPayment.continue'))
                        )}
                      </Button>
                    )}
                  />
                </form>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: '50px' }}>
              <RegularSpinner />
            </div>
          )}
        </div>
      )}
      {!showDocument && !showMessage && (
        <div className='w-full h-full flex flex-col gap-8 items-center justify-around'>
          {showSpinner ? (
            <div style={{ marginTop: '50px' }}>
              <RegularSpinner />
            </div>
          ) : null}
          {}
        </div>
      )}
      {showMessage && (
        <div className={cx('message-container')}>
          <div className={cx('message-container')}>
            <p className={cx('message-container-text')}>
              {GlobalService.uppercaseFirstLetter(
                t('modal.transferencia.confirmTransferMethodMessage'),
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SplitPayment;
